import SiteLayout from "@/components/layout/SiteLayout";
import Seo from "@/components/base/Seo";
import SectionHeading from "@/components/base/SectionHeading";
import EmergencyHero from "./components/EmergencyHero";
import EmergencyServiceGrid from "./components/EmergencyServiceGrid";
import EmergencyListingsSection from "./components/EmergencyListingsSection";
import CallEmergencyButton from "./components/CallEmergencyButton";
import FirstAidBasics from "./components/FirstAidBasics";

const emergencySteps = [
  {
    id: "step-1",
    icon: "ri-shield-star-line",
    title: "Stay calm & stay safe",
    description:
      "Check whether anyone is still in danger and move to a safe spot if you can, without putting yourself at risk.",
  },
  {
    id: "step-2",
    icon: "ri-phone-fill",
    title: "Call 112 first",
    description:
      "In a life-threatening situation dial 112 — a single number that reaches police, fire and ambulance services.",
  },
  {
    id: "step-3",
    icon: "ri-map-pin-user-line",
    title: "Share clear details",
    description:
      "Give your exact location with a landmark, how many people are hurt, and what kind of help you need.",
  },
];

export default function EmergencyServicesPage() {
  return (
    <SiteLayout>
      <Seo
        title="Emergency Services & Helplines in Coastal Karnataka"
        description="24x7 emergency services in coastal Karnataka — national helplines plus verified hospitals, ambulances, blood banks, pharmacies and diagnostic labs near you."
        keywords="emergency services Karnataka, 24x7 hospital Mangaluru, ambulance service Udupi, blood bank, pharmacy near me, police station, fire rescue"
        path="/emergency-services"
      />

      <EmergencyHero />

      <section className="bg-background-50">
        <div className="mx-auto w-full max-w-[1400px] px-6 py-12 md:py-16">
          <SectionHeading
            eyebrow="Find help fast"
            title="Browse by emergency service"
            description="Pick the service you need and we'll take you straight to the relevant verified businesses nearby."
          />
          <div className="mt-8">
            <EmergencyServiceGrid />
          </div>
        </div>
      </section>

      <EmergencyListingsSection />

      <section className="bg-background-50">
        <div className="mx-auto w-full max-w-[1400px] px-6 py-12 md:py-16">
          <SectionHeading
            eyebrow="Before you call"
            title="What to do in an emergency"
            description="A few seconds of the right information can make a real difference while help is on the way."
          />
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            {emergencySteps.map((step, index) => (
              <article
                key={step.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                    <i className={`${step.icon} text-xl`} />
                  </span>
                  <span className="flex h-6 min-w-[1.5rem] items-center justify-center rounded-full bg-secondary-100 px-2 font-heading text-xs font-bold text-secondary-800">
                    Step {index + 1}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {step.description}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <FirstAidBasics />

      <CallEmergencyButton />
    </SiteLayout>
  );
}